import styled from 'styled-components'

import theme from '~/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${theme.tokens.spacingUnit * 2.5}px;
`
